import type { ButtonGroupOption } from '/react4xp/components/react-hook-form/ButtonGroup';
import type { Phrases } from './Phrases.d';

import {
	// faCloud,
	faDiceD8,
	faFlaskPotion,
	faMortarPestle,
	faNose,
	faPills,
} from '@fortawesome/pro-light-svg-icons';
import { faCapsules } from '@fortawesome/pro-regular-svg-icons';
import React, {
	// useEffect,
	useMemo,
	// useRef,
} from 'react';
// import { useWatch } from 'react-hook-form';
// import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
// import { ButtonGroup } from '../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	COMMON_ENUM_FIELD_NAME,
	COMMON_FIELD_NAME,
	COMMON_FREETEXT_FIELD_NAME,
	SUBSTANCE_FORM,
} from './constants';


export const SubstanceFormButtonGroup = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	// const ref = useRef<HTMLElement>(null);
	// const { control } = useFormContext();
	// const form = useWatch({control, name: COMMON_FIELD_NAME.SUBSTANCE_FORM});
	// useEffect(() => {
	// 	if (ref.current) {
	// 		console.debug('SubstanceFormButtonGroup ref yay!');
	// 		ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
	// 	}
	// }, [
	// 	form
	// ]);

	const SUBSTANCE_FORM_OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		icon: faPills,
		label: phrases['notificationForm.common.formField.value.pill'],
		value: SUBSTANCE_FORM.PILL,
	},{
		icon: faCapsules,
		label: phrases['notificationForm.common.formField.value.capsule'],
		value: SUBSTANCE_FORM.CAPSULE,
	},{
		icon: faNose,
		label: phrases['notificationForm.common.formField.value.nasalSpray'],
		value: SUBSTANCE_FORM.NASAL_SPRAY,
	},{
		icon: faDiceD8,
		label: phrases['notificationForm.common.formField.value.crystal'],
		value: SUBSTANCE_FORM.CRYSTAL,
	},{
		icon: faMortarPestle,
		label: phrases['notificationForm.common.formField.value.powder'],
		value: SUBSTANCE_FORM.POWDER,
	},{
		icon: faFlaskPotion,
		label: phrases['notificationForm.common.formField.value.liquid'],
		value: SUBSTANCE_FORM.LIQUID,
	// },{
	// 	icon: faCloud,
	// 	label: phrases['notificationForm.common.formField.value.gas'],
	// 	value: SUBSTANCE_FORM.GAS,
	},{
		label: phrases['notificationForm.common.formField.value.other'],
		value: SUBSTANCE_FORM.OTHER,
	}], [phrases]);

	return (
		<ButtonRadioGroup
			// TODO: This can either be done here, or with useEffect in each component.
			afterClick={({
				setValue,
			}) => {
				// ERROR: Setting value to empty string on enums
				// or literal unions causes validation to fail!
				setValue(COMMON_ENUM_FIELD_NAME.PILL_SHAPE, undefined);

				// Empty array works though
				setValue(COMMON_ENUM_FIELD_NAME.COLOR, []);
				setValue(COMMON_ENUM_FIELD_NAME.CAPSULE_POWDER_COLOR, []);

				// Yes, empty string can be set on optional text fields.
				setValue(COMMON_FREETEXT_FIELD_NAME.PILL_SHAPE_OTHER, '', { shouldValidate: true });
				setValue(COMMON_FREETEXT_FIELD_NAME.COLOR_OTHER, '', { shouldValidate: true });
				setValue(COMMON_FREETEXT_FIELD_NAME.CAPSULE_POWDER_COLOR_OTHER, '', {
					shouldValidate: true,
				});
				setValue(COMMON_FREETEXT_FIELD_NAME.INTOXICANT_DESCRIPTION, '', {
					shouldValidate: true,
				});
			}
			}
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			label={phrases['notificationForm.common.formField.label']}
			name={COMMON_FIELD_NAME.SUBSTANCE_FORM}
			options={SUBSTANCE_FORM_OPTIONS}
			// ref={ref}
		/>
	);
};

